import { createContext, useContext } from "react";

export type SetLocale = (locale: string) => void;

export const SetLocaleContext = createContext<SetLocale>(() => {});

export const useSetLocale = (): SetLocale => useContext(SetLocaleContext);
